export default __webpack_public_path__ + "static/media/BCA9.cc27470a.jpg";